import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import { WalletProvider } from '../../context/wallet/WalletContext';
import WalletHeader from './sections/Header/WalletHeader';
import WalletLockBanner from './sections/Banners/WalletLockBanner';
import WalletBalanceCard from './sections/Overview/WalletBalanceCard';
import WalletStatsCard from './sections/Overview/WalletStatsCard';
import WalletCommissionInfoStrip from './sections/InfoStrip/WalletCommissionInfoStrip';
import WalletTransactionControls from './sections/Transactions/WalletTransactionControls';
import WalletTransactionsTable from './sections/Transactions/WalletTransactionsTable';
import WalletMobileTransactionsList from './sections/Transactions/WalletMobileTransactionsList';
import RedemptionModal from './sections/Modals/RedemptionModal';

const WalletContent = () => {
  return (
    <PageContainer className="min-h-screen font-sans text-slate-800 space-y-6 pb-28 sm:pb-32 lg:pb-12">
      {/* Header Section */}
      <WalletHeader />

      {/* Wallet Lock Alert Banner on Starter Plan */}
      <WalletLockBanner />

      {/* Hero Financial Overview Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <WalletBalanceCard />
        <WalletStatsCard />
      </div>

      {/* How Commission Works Info Strip */}
      <WalletCommissionInfoStrip />

      {/* Transactions & History Section */}
      <div className="bg-white rounded-3xl shadow-sm border border-slate-200/80 overflow-hidden">
        <WalletTransactionControls />
        <WalletTransactionsTable />
        <WalletMobileTransactionsList />
      </div>

      {/* Redemption Payout Modal */}
      <RedemptionModal />
    </PageContainer>
  );
};

const WalletPage = () => {
  return (
    <MainLayout activeTab="wallet" setActiveTab={() => {}}>
      <WalletProvider>
        <WalletContent />
      </WalletProvider>
    </MainLayout>
  );
};

export default WalletPage;
